"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _Pill = _interopRequireDefault(require("../../Pill/Pill"));
var FlexTextGrid = function FlexTextGrid(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, data.title && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-center"
  }, data.title), data.items && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(data.items.length < 3 && 'max-width-sm margin-auto', " d8-l-auto-grid")
  }, data.items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(data.center && 'text-center'),
      key: JSON.stringify(item)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-bottom-sm"
    }, /*#__PURE__*/_react["default"].createElement(_Pill["default"], {
      icon: item.icon,
      iconcolor: item.iconcolor,
      title: item.title
    })), /*#__PURE__*/_react["default"].createElement("p", null, item.text));
  })));
};
FlexTextGrid.propTypes = {
  data: _propTypes["default"].object
};
var _default = exports["default"] = FlexTextGrid;